/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const bowling = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.667 6.724V2.4a1.4 1.4 0 0 0-2.8 0v4.324m2.8 0c1.167 1.278 1.83 1.879 1.866 3.61a7.105 7.105 0 0 1-1.56 4.313.933.933 0 0 1-.732.353H3.292a.935.935 0 0 1-.73-.353A7.105 7.105 0 0 1 1 10.333c.036-1.73.7-2.33 1.867-3.609m2.8 0h-2.8m6.412-.938a4.666 4.666 0 1 1 0 9.093m1.706-6.852h.023m-.493 2.332h.023m2.314-.468h.023"
    />
  </svg>
)
export default bowling
